import { useEffect, useRef } from 'react'

/**
 * Calls <c>fn</c> every <c>ms</c> milliseconds while <c>enabled</c>, using recursive
 * setTimeout (each tick is scheduled only after the previous one runs). The latest <c>fn</c>
 * is always used without restarting the loop. This is the COTC polling transport until the
 * SignalR upgrade lands (Foundation Debt).
 */
export function usePoll(fn: () => void, ms: number, enabled = true) {
  const saved = useRef(fn)
  saved.current = fn

  useEffect(() => {
    if (!enabled) return
    let stopped = false
    let handle: ReturnType<typeof setTimeout>

    const loop = () => {
      handle = setTimeout(() => {
        if (stopped) return
        saved.current()
        loop()
      }, ms)
    }
    loop()

    return () => {
      stopped = true
      clearTimeout(handle)
    }
  }, [ms, enabled])
}
